<template>
    <div>
        <div v-if="$root.edit && products.length == 0" class="pa-4">
            <v-card color="zoezi-edit-color" dark height="100">
                <v-card-title>{{$translate('No products have been linked to the buy button')}}</v-card-title>
            </v-card>
        </div>
        <component-wrapper v-else :config="component" @click.native="buttonClicked" />

        <bottom-dialog v-model="showCheckout" scrollable max-width="850px" :dialog="!$vuetify.breakpoint.mobile" v-if="showCheckout">
            <v-card class="zoezi-bottom-sheet" tile elevation="0">
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        {{$translate('Complete the purchase')}}
                        <v-btn icon @click="showCheckout = false" class="float-right" v-if="!checkoutLoading"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>

                <v-card-text :class="{'px-2': $vuetify.breakpoint.mobile }" class="z-no-x-scroll pb-0" style="min-height: 50vh">
                    <checkout
                        ref="checkout"
                        class="overflow-y-auto"
                        :items="checkoutProducts"
                        :expand-first-item="false"
                        :show-summary="true"
                        :show-back-link="false"
                        :show-payment-button="false"
                        :new-style-done-dialog="true"
                        @done="showCheckout = false"
                        @loading="checkoutLoading = $event"
                        :scroll-payment-part="true"
                        :countReadOnly="true"
                        @readyToPay="readyToPay = $event"
                        @cost="cost = $event"
                        @paymentMethod="paymentMethod = $event"
                        @changeItemUsers="changeItemUsers"
                        :dialog="true"
                    >
                        <template #content>
                            <stepper-content v-model="currentStep" :steps="steps" class="overflow-y-auto">
                                <template #checkout>
                                    <portal-target name="checkoutcontent" />
                                </template>
                            </stepper-content>
                        </template>
                    </checkout>
                </v-card-text>
                <v-card-actions>
                    <stepper v-model="currentStep" :steps="steps" @cancel="showCheckout = false" ref="stepper"  :disabled="checkoutLoading" :show-title="false" />
                </v-card-actions>
            </v-card>
        </bottom-dialog>
    </div>
</template>

<script>
import components from '../component.js'
import BottomDialog from '../components/BottomDialog.vue'
import Checkout from '../views/Checkout.vue'
import Stepper from '../views/Stepper.vue'
import StepperContent from '../views/StepperContent.vue'
import {formatPrice} from '../util.js'
export default {
    name: 'zoezi-checkout-button',

    zoezi: {
        title: 'Checkout button',
        icon: 'mdi-cart-arrow-right'
    },

    components: {
        BottomDialog,
        Checkout,
        Stepper,
        StepperContent
    },

    props: {
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({component: 'zoezi-button', props: {text: 'Köp'}})
        },
        products: {
            title: 'Products',
            type: Array,
            fulltype: 'productlist',
            default: () => []
        },
        useCart: {
            title: 'Use shopping cart',
            type: Boolean,
            default: false,
            section: 'Shopping cart'
        },
        cartName: {
            title: 'Name of shopping cart',
            type: String,
            default: '',
            section: 'Shopping cart',
            typeinfo: {
                placeholder: 'Use the standard shopping cart',
                //visible: 'useCart'
            }
        },
        openCheckout: {
            title: 'Open checkout on click',
            type: Boolean,
            default: true,
            section: 'Shopping cart'
            /*typeinfo: {
                visible: 'useCart'
            }*/
        },
        showBottomBar: {
            title: 'Show shopping cart on click',
            type: Boolean,
            default: false,
            section: 'Shopping cart'
            /*typeinfo: {
                visible: 'useCart'
            }*/
        }
    },

    watch: {
        showCheckout: {
            immediate: true,
            handler(showCheckout, oldShowCheckout) {
                if (showCheckout) {
                    this.checkoutProducts = this.products ? this.products.concat() : null;
                    if (this.checkoutProducts) {
                        let user = this.$store.state.user;
                        this.checkoutProducts.forEach(x => {
                            x.users = new Array(x.count).fill(user ? user.id : null);
                        });
                    }
                }

                if (showCheckout != oldShowCheckout && oldShowCheckout !== undefined) {
                    this.$emit('showCheckout', showCheckout)
                }
            }
        },
        '$store.state.isLoggedIn'(loggedIn) {
            if (loggedIn && this.showCheckout && this.checkoutProducts) {
                let user = this.$store.state.user;
                this.checkoutProducts.forEach(x => {
                    x.users = new Array(x.count).fill(user ? user.id : null);
                });
            }
        }
    },

    data: () => ({
        showCheckout: false,
        checkoutLoading: false,
        readyToPay: false,
        cost: 0,
        currentStep: 0,
        paymentMethod: null,
        checkoutProducts: null
    }),

    computed: {
        steps() {
            let nextTitle = this.cost > 0 ? `Betala ${formatPrice(this.cost)}` : 'Bekräfta köp';
            if (this.paymentMethod == 'unknown' || this.paymentMethod == 'invoice' || this.paymentMethod == 'directdebit') {
                nextTitle = `Bekräfta köp ${formatPrice(this.cost)}`;
            } else if (!this.paymentMethod) {
                nextTitle = this.$translate('Choose payment method');
            }
            return [
                {title: 'Slutför', id: 'checkout', nextTitle, nextColor: '#7bbd1b', nextDark: true, nextClicked: this.pay, nextLoading: this.checkoutLoading, complete: this.readyToPay }
            ];
        }
    },

    methods: {
        buttonClicked($event) {
            if (this.$root.edit) {
                if ($event) {
                    $event.preventDefault();
                }
            } else if (!this.useCart) {
                this.showCheckout = true;
            } else {
                this.products.forEach(item => {
                    this.$store.dispatch('addToCart', {cartName: this.cartName, product_id: item.product_id, count: item.count, variant: item.variant, price: item.price});
                });
                if (this.openCheckout) {
                    this.$store.dispatch('setCartVisibility', {cartName: this.cartName, showBottomBar: false, showCheckout: true});
                } else if (this.showBottomBar) {
                    this.$store.dispatch('setCartVisibility', {cartName: this.cartName, showBottomBar: true, showCheckout: false});
                }
            }
        },
        pay() {
            this.$refs.checkout.completePurchase();
        },
        changeItemUsers(item, users) {
            let existing = this.checkoutProducts.find(x => x.product_id == item.product_id && x.variant == item.variant)
            existing.users = users.concat();
            this.checkoutProducts = this.checkoutProducts.concat();
        }
    }
}
</script>
